import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { defineMessages } from "react-intl";
import { injectIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const messages = defineMessages({
    showAllInvoicesFromCreditor: {
        id: "Näytä kaikki laskut yritykseltä",
        defaultMessage: "Näytä kaikki laskut yritykseltä"
    }
});

const CreditorInvoicesButton = (props) => {
    const lng = props.intl.formatMessage;
    const navigate = useNavigate();

    /**
     * Redirect back to dashboard 
     * and use creditor name as search parameter
     */
    const handleShowAllInvoices = () => {
        navigate({ pathname: "/jobsearch", search: `?s=${props.job.payee.name}`});
    }

    return (
        <Button variant='tertiary' className='ps-md-0 pe-md-0' onClick={handleShowAllInvoices}>
            {lng(messages.showAllInvoicesFromCreditor)} {props.job.payee.name}
        </Button>
    );
};

CreditorInvoicesButton.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object,
};

export default injectIntl(CreditorInvoicesButton);